export default "__VITE_ASSET___sPDCWyk__"